var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m.522 1.85.975 9.75a1 1 0 0 0 .995.9h7.973a1 1 0 0 0 .995-.9l.975-9.75a.1.1 0 0 0-.158-.091l-3.53 2.52a.1.1 0 0 1-.147-.036L6.568.18a.1.1 0 0 0-.18 0L4.358 4.243a.1.1 0 0 1-.148.037L.68 1.759a.1.1 0 0 0-.157.091Z",
  fill: "#E29C09"
})));
export default SvgVip;